<template>
	<AsiDialogFormLayout :icon="icons.state" :title="$t('item.stockStateOverride')"
	                     :open="open" :loading="loading" :valid="valid" :errors="errors"
	                     @save="requestSave" @cancel="cancel" unwrapped scrollable>
		<v-card-text class="pa-6">
			<v-form v-model="valid">
				<v-row>
					<v-col>
						<AsiSelect v-model="stockStatusOverride" :label="$t('item.stockStateOverride')" :placeholder="$t('item.stockState')"
						           :items="options" :rules="rules"/>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
	</AsiDialogFormLayout>
</template>

<script lang="ts">
	import {Component, Emit, Prop, Watch} from "vue-property-decorator";
	import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
	import AsiSelect from "@/components/common/AsiSelect";
	import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
	import {StockStatus} from "@/helpers/constants";
	import EnumHelper from "@/helpers/EnumHelper";
	import {ValidationRule} from "@/declarations/ValidationRule";
	import {IItemShop} from "@/models/item/ItemShopModels";
	import ItemRules from "@/models/item/ItemRules";
	import AsiAlert from "@/components/common/AsiAlert.vue";
	import {IItemAdmin} from "@/models/item/ItemAdminModels";
	@Component({
		components: {AsiAlert, AsiSelect, AsiDialogFormLayout}
	})
	export default class ItemUpdateDialogStockState extends AsiDialogForm {
		@Prop({type: Object, required: true})
		public item!: IItemShop | IItemAdmin;

		private stockStatusOverride: StockStatus | null = null;

		// noinspection JSMethodCanBeStatic
		private get options(): { text: string; value: string | number | null }[] {
			return [
				{
					text: this.$t('constants.noOverride').toString(),
					value: null,
				},
				...EnumHelper.toSelectItems(StockStatus, true),
			];
		}

		// noinspection JSMethodCanBeStatic
		private get rules(): ValidationRule[] {
			return ItemRules.stockStateRules;
		}

		@Watch('item.stockStatusOverride', {immediate: true})
		private onItemStateChanged(value: StockStatus): void {
			this.stockStatusOverride = value;
		}

		@Emit('save')
		public save(): void {
			return;
		}

		@Emit('cancel')
		public cancel(event: Event): Event {
			this.stockStatusOverride = this.item.stockStatusOverride;
			const form = this.$refs.form as HTMLFormElement;
			this.reset([], form);
			return event;
		}

		private requestSave(): void {
			this.loading = true;

			this.$itemServiceAdmin.updateStockState(this.item.id, this.stockStatusOverride)
				.then(this.save)
				.catch(this.handleErrors)
				.finally(() => this.loading = false);
		}
	}
</script>

<style lang="scss" scoped>

</style>
